<template>
    <div id="secure">
        <!-- START NAV -->
        <TopMenu />
        <!-- END NAV -->
        <div class="container">
            <div class="columns">
                <div class="column is-12">
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a v-on:click="goHome()">Super Admin</a>
                            </li>
                            <li class="is-active">
                                <a href="#" aria-current="page">Schools</a>
                            </li>
                        </ul>
                    </nav>
                    <section class="info-tiles">
                        <div class="card">
                            <header class="card-header">
                                <loading
                                    :active.sync="isLoading1"
                                    :can-cancel="false"
                                    :is-full-page="false">
                                </loading>
                                <div class="tile is-ancestor has-text-centered">
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ schoolCount }}</p>
                                            <p class="subtitle">Schools</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ premiumCount }}</p>
                                            <p class="subtitle">Premium</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ premiumTrialCount }}</p>
                                            <p class="subtitle">Premium (1 Month Trial)</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ freeForeverCount }}</p>
                                            <p class="subtitle">Free Forever</p>
                                        </article>
                                    </div>
                                </div>
                            </header>
                        </div>
                        <div class="card">
                            <a class="button is-small is-info" v-on:click="goManageSchoolTypes()" style="margin-left: 10px;">Manage School Types</a>
                        </div>
                        <div class="card is-hidden1">
                            <div class="card-header" style="padding: 10px;">
                                <b-select id="getReportLinkForSchool" name="getReportLinkForSchool" v-model="getReportLinkForSchool" size="is-small" style="margin-left: 10px;">
                                    <option selected value="all">All School</option>
                                    <option v-for="school in listActiveSchool" :key="school._id" :value="school._id">{{ school.name }}</option>
                                </b-select>                                
                                <b-select id="getReportLinkMonth" name="getReportLinkMonth" v-model="getReportLinkMonth" size="is-small" style="margin-left: 10px;">
                                    <option selected value="1">January</option>
                                    <option selected value="2">February</option>
                                    <option selected value="3">March</option>
                                    <option selected value="4">April</option>
                                    <option selected value="5">May</option>
                                    <option selected value="6">June</option>
                                    <option selected value="7">July</option>
                                    <option selected value="8">August</option>
                                    <option selected value="9">September</option>
                                    <option selected value="10">October</option>
                                    <option selected value="11">November</option>
                                    <option selected value="12">December</option>
                                </b-select>
                                <a class="button is-small is-info" v-on:click="getReportLink()" style="margin-left: 10px;">Get Report Link</a>
                                <loading
                                    :active.sync="isLoading4"
                                    :can-cancel="false"
                                    :is-full-page="false">
                                </loading>
                            </div>
                        </div>
                    </section>
                    <!-- <div class="modal" v-bind:class="{ active: displayReportLink }" v-on:click="displayReportLink = !displayReportLink">
                        <div class="modal-background"></div>
                        <div class="modal-content" style="padding: 10px;">
                            content la
                        </div>
                        <button class="modal-close is-large" aria-label="close"></button>
                    </div> -->
                    <div class="columns">
                        <div class="column is-12">
                            <div class="card events-card">
                                <header class="card-header">
                                    <p class="card-header-title">Premium (1 Month Trial)</p>
                                </header>
                                <div class="card-table">
                                    <div class="content">                                        
                                        <loading
                                            :active.sync="isLoading2"
                                            :can-cancel="false"
                                            :is-full-page="false">
                                        </loading>
                                        <table class="table is-fullwidth is-striped">
                                            <tbody>
                                                <tr v-for="school in listPremiumTrialSchool" :key="school._id">
                                                    <td v-on:click="viewSchool(school._id,school.name)" style="cursor: pointer;">{{ school.name }}</td>
                                                    <td>{{ moment(school.addedOn).startOf('hour').fromNow() }} </td>
                                                    <td class="level-right">
                                                        <a class="button is-small is-primary" v-on:click="viewSchool(school._id,school.name)">View Info</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card events-card">
                                <header class="card-header">
                                    <p class="card-header-title">Free Forever</p>
                                </header>
                                <div class="card-table">
                                    <div class="content">                                        
                                    <loading
                                        :active.sync="isLoading3"
                                        :can-cancel="false"
                                        :is-full-page="false">
                                    </loading>
                                        <table class="table is-fullwidth is-striped">
                                            <tbody>
                                                <tr v-for="school in listFreeSchool" :key="school._id">
                                                    <td v-on:click="viewSchool(school._id,school.name)" style="cursor: pointer;">{{ school.name }}</td>
                                                    <td>{{ moment(school.addedOn).startOf('hour').fromNow() }} </td>
                                                    <td class="level-right">
                                                        <a class="button is-small is-primary" v-on:click="viewSchool(school._id,school.name)">View Info</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card events-card">
                                <header class="card-header">
                                    <p class="card-header-title">Premium</p>
                                </header>
                                <div class="card-table">
                                    <div class="content">
                                        <loading
                                            :active.sync="isLoading3"
                                            :can-cancel="false"
                                            :is-full-page="false">
                                        </loading>
                                        <table class="table is-fullwidth is-striped">
                                            <tbody>
                                                <tr v-for="school in listPremiumSchool" :key="school._id">
                                                    <td v-on:click="viewSchool(school._id,school.name)" style="cursor: pointer;">{{ school.name }}</td>
                                                    <td>{{ moment(school.addedOn).startOf('hour').fromNow() }} </td>
                                                    <td class="level-right">
                                                        <a class="button is-small is-primary" v-on:click="viewSchool(school._id,school.name)">View Info</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopMenu from "./TopMenu";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Datepicker from "vuejs-datepicker";
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: "SuperSchools",
    components: {
        TopMenu,
        Loading
    },
    data() {
        return {
            superId: "",
            superEmail: "",
            isLoading1: false,
            isLoading2: false,
            isLoading3: false,
            isLoading4: false,
            schoolCount: 0,
            premiumCount: 0,
            premiumTrialCount: 0,
            freeForeverCount: 0,
            listSchool: [],
            listPremiumSchool: [],
            listPremiumTrialSchool: [],
            listFreeSchool: [],
            listActiveSchool: [],
            getReportLinkForSchool: "all",
            getReportLinkMonth: 1
        };
    },
    created() {
        this.superId = localStorage.getItem("superId");
        this.superEmail = localStorage.getItem("superEmail");
        this.getAll();
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        getAll() {
            let self = this;
            self.isLoading1 = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    what: "all"
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listSchool = response.data.listSchool
                        console.log("224 self.listSchool.length: " + self.listSchool.length)
                        self.schoolCount = self.listSchool.length

                        var planCount = _.countBy(self.listSchool, 'plan')
                        self.premiumCount = planCount["1"]
                        self.premiumTrialCount = planCount["2"]
                        self.freeForeverCount = planCount["3"]

                        var listSchoolByPlan = _.groupBy(self.listSchool, 'plan')
                        self.listPremiumSchool = listSchoolByPlan["1"]
                        self.listPremiumTrialSchool = listSchoolByPlan["2"]
                        self.listFreeSchool = listSchoolByPlan["3"]

                        self.listActiveSchool = _.filter(self.listSchool, x => x.status === 1);
                        self.listActiveSchool = _.orderBy(self.listActiveSchool, 'name', 'asc')
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading1 = false;
                });
        },
        viewSchool(schoolID,schoolName){
            console.log("entering viewSchool with " + schoolID + ", " + schoolName)
            
            this.$store.commit('SUPER_UPDATE_VIEW_SCHOOL_ID',schoolID)
            this.$store.commit('SUPER_UPDATE_VIEW_SCHOOL_NAME',schoolName)
            localStorage.setItem('SUPER_VIEW_SCHOOL_ID',schoolID)
            localStorage.setItem('SUPER_VIEW_SCHOOL_NAME',schoolName)

            this.$router.push({
                name: "SuperSchoolEdit"
            });
        },
        displayPlan(plan){
            if (!plan){
                return "Full"
            }else{
                if (plan == 1){
                    return "Full"
                }else if (plan == 2){
                    return "1 month unlimited trial"
                }else if (plan == 3){
                    return "Free Forever"
                }else{
                    return "Invalid Plan"
                }
            }
        },
        getReportLink(){
            console.log("clicked 308")
            let self = this;
            self.isLoading4 = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + "/super/reportLink", {
                    superEmail: localStorage.getItem("superEmail"),
                    selectedSchool: self.getReportLinkForSchool,
                    month: self.getReportLinkMonth
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "report_links.xlsx"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    self.isLoading4 = false;
                })
                .catch(e => {
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading4 = false;
                });
        },
        goHome() {
            this.$router.push({
                name: "SuperHome"
            });
        },
        goManageSchoolTypes(){
            this.$router.push({
                name: "SuperSchoolTypes"
            });
        },
    }
};
</script>

<style scoped>
html,
body {
    font-size: 16px;
    line-height: 1.5;
    height: 100%;
    background: #ecf0f3;
}
nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
}
.navbar-item.brand-text {
    font-weight: 300;
}
.navbar-item,
.navbar-link {
    font-size: 14px;
    font-weight: 700;
}
.columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
}
.menu-label {
    color: #8f99a3;
    letter-spacing: 1.3;
    font-weight: 700;
}
.menu-list a {
    color: #0f1d38;
    font-size: 14px;
    font-weight: 700;
}
.menu-list a:hover {
    background-color: transparent;
    color: #276cda;
}
.menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
}
.card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
}
.card-header-title {
    color: #8f99a3;
    font-weight: 400;
}
.info-tiles {
    margin: 1rem 0;
}
.info-tiles .subtitle {
    font-weight: 300;
    color: #8f99a3;
}
.hero.welcome.is-info {
    background: #36d1dc;
    background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
    background: linear-gradient(to right, #5b86e5, #36d1dc);
}
.hero.welcome .title,
.hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
}
.card .content {
    font-size: 14px;
}
.card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8f99a3;
}
.card-table .table {
    margin-bottom: 0;
}
.events-card .card-table {
    max-height: 250px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Super/Schools.vue